/* Small, one-time entrances. Content is visible even if scripting is unavailable. */
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  let observer;
  const selectors = '.autumn-section-heading, .autumn-department, .autumn-caviar-art, .autumn-caviar-copy, .autumn-story header, .autumn-story-points > div, .autumn-brand-list, .autumn-collection-heading';
  function connect(root = document) {
    if (preference.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (seen.has(target)) return;
        seen.add(target);
        const index = Array.from(target.parentElement.children).indexOf(target);
        const animation = target.animate([
          { opacity: .35, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 680, delay: Math.min(index % 3, 2) * 65, easing: 'cubic-bezier(.22,1,.36,1)' });
        running.add(animation);
        animation.finished.catch(() => {}).finally(() => running.delete(animation));
      });
    }, { threshold: .12 });
    root.querySelectorAll(selectors).forEach(element => {
      if (!seen.has(element)) observer.observe(element);
    });
  }
  preference.addEventListener('change', () => {
    observer?.disconnect();
    running.forEach(animation => animation.cancel());
    if (!preference.matches) connect();
  });
  document.addEventListener('shopify:section:load', event => connect(event.target));
  connect();
})();
